import React, { Component } from 'react';
import { getUrlId, RedirectToUrlDirect } from '../Utils/responseHandler';
import withRouter from '../hoc/withRouter';
import apiClient from '../Utils/apiClient';
import { toastSuccess, toastError } from '../Utils/toast';
const _ = require('lodash');

export class EditService extends Component {

    constructor(props) {
        super(props)
        this.state = {
            data: {},
            title: "Extra Fields",
            formValues: [{ name: "", description: "", short: "", status: "", extra_fields: "" }],
            extraValues: [],
            service_fields: [],
            messageError: "",
            messageSuccess: "",
            isLoading: true,
            navigate: this.props,
        };
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    mainChange(i, e) {
        let formValues = this.state.formValues;
        formValues[0][e.target.name] = e.target.value;
        this.state.data[e.target.name] = e.target.value;
        this.setState({ formValues: formValues });
    }

    handleServiceValueChange(i, e) {
        let service_fields = this.state.service_fields;
        if (service_fields[i].id) {
            service_fields[i].value = e.target.value;

        } else {
            service_fields[i]['value'] = e.target.value;
        }
        this.setState({ service_fields });
    }

    handleServiceNameChange(i, e) {
        let service_fields = this.state.service_fields;
        if (service_fields[i].id) {
            service_fields[i].name = e.target.value;

        } else {
            service_fields[i]['name'] = e.target.value;
        }
        this.setState({ service_fields });
    }

    addFormFields() {
        this.setState(({
            service_fields: [...this.state.service_fields, {}]
        }))
    }
    async removeFormFields(i, el) {
        if (!_.isEmpty(el[i])) {
            console.log(el[i].id);
            let res = await
                apiClient.delete('services/fields/' + el[i].id)
                    .then(response => { console.log(response) })
                    .catch(error => {
                        console.error('Error fetching data:', error);
                    });
        }
        let service_fields = this.state.service_fields;
        service_fields.splice(i, 1);
        this.setState({ service_fields });
    }

    async handleSubmit(e) {
        e.preventDefault();
        let output = [];
        let mainvalue = this.state.formValues[0];
        let extvalue = this.state.service_fields;
        mainvalue['service_fields'] = extvalue;
        console.log(this.state.formValues[0])
        console.log(mainvalue)
        try {

            let res = await apiClient.put('services/' + getUrlId(), mainvalue);
            let resJson = res.data;

            if (resJson.error === false) {
                var errorObj = []
                resJson.data.forEach(element => {
                    errorObj[element.field] = (errorObj[element.field])? errorObj[element.field] + ', ' + element.message: element.message
                });
                this.setState({ messageError: errorObj});
                toastError('Failed to update service');
            }
            if (resJson && resJson.success) {
                this.setState({ messageSuccess: "service has been registered!!" });
                toastSuccess('Service updated');
                window.location.replace('/services');
            }
        } catch (err) {
            console.log(err);
            this.setState({ messageError: "Some error occured" });
            toastError(err.response?.data?.message || 'Some error occurred');
        }
    }

    async fetchData() {
        const id = getUrlId();
        try {
            apiClient.get('services/' + id)
                .then(response => response.data)
                .then(res => {
                    this.setState({
                        data: res.data,
                        formValues: [{
                            name: res.data.name,
                            description: res.data.description,
                            short: res.data.short,
                            status: res.data.status,
                        }],
                        service_fields: res.data.service_fields,
                        isLoading: false,
                    });
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            this.setState({ isLoading: false });
        }
    }
    componentDidMount() {
        this.fetchData();
    }

    render() {
        const { name, description, short, status, extra_fields } = this.state.formValues[0];
        const { data, service_fields, formValues, isLoading } = this.state;
        if (isLoading) {
            return <div className="loader"></div>;
        }
        if (!data) {
            return <div>No data found.</div>;
        }
        return (
            <div className="main-panel">
                <div className="content-wrapper">
                    <div className="card registration_form" >
                        <div className="modal-header">
                            <h3 className="modal-title">Edit Service</h3>
                        </div>
                        <form onSubmit={this.handleSubmit} >
                            <div className="modal-body">
                                <div className="message">
                                    {
                                        this.state.messageSuccess ? <p className='alert alert-success'>{this.state.messageSuccess}</p>
                                           
                                                : null
                                    }
                                </div>
                                <div className='row' >
                                    <div className='col-lg-6'>
                                        <div className="form-group text-left">
                                            <label className="form-group-text">Name</label>
                                            <input type="text" className="form-control" name="name"
                                                value={data.name}
                                                onChange={e => this.mainChange('name', e)} />
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['name']}</span>}

                                        </div>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className="form-group text-left">
                                            <label className="form-group-text">Shortname</label>
                                            <input type="text" className="form-control" name="short" disabled value={data.short}
                                                onChange={e => this.mainChange(formValues.short, e)} />
                                        </div>
                                    </div>
                                    <div className='col-lg-12'>
                                        <div className="form-group text-left">
                                            <label className="form-group-text">Description</label>
                                            <input type="text" className="form-control" name="description" value={data.description}
                                                onChange={e => this.mainChange(formValues.description, e)} />
                                        </div>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className="form-group text-left">
                                            <label className="form-group-text">Status</label>
                                            <select className="form-select form-control" name="status"
                                                onChange={e => this.mainChange(formValues.status, e)}
                                                value={data.status}>
                                                <option value="true">Active</option>
                                                <option value="false">In Active</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {this.state.title ? <h4 className='text-left'>{this.state.title}</h4> : null}
                                {service_fields.map((item, index) => (
                                    <div className='row form-group' key={index}>
                                        <div className='col-lg-5'>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name='name'
                                                value={(item.name) ?? ''}
                                                onChange={(e) => this.handleServiceNameChange(index, e)}
                                            />
                                        </div>
                                        <div className='col-lg-6'>
                                            {
                                                (item.type == 'textarea') ?
                                                    <textarea type={(item.type) ? item.type : "text"}
                                                        className="form-control"
                                                        name='value'
                                                        value={item.value ?? ''}
                                                        onChange={(e) => this.handleServiceValueChange(index, e)}
                                                    ></textarea>
                                                    :
                                                    <input
                                                        type={(item.type) ? item.type : "text"}
                                                        className="form-control"
                                                        name='value'
                                                        value={item.value}
                                                        onChange={(e) => this.handleServiceValueChange(index, e)}
                                                    />
                                            }
                                        </div>
                                        <div className='col-lg-12'>{this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['service_fields']}</span>} </div>
                                        {
                                            index ?
                                                <div className='col-lg-1'>
                                                    <button type="button" className="btn btn-icon btn-rounded btn-warning remove float-right" onClick={() => this.removeFormFields(index, service_fields)}><i className='bi bi-trash-fill'></i></button>
                                                </div>
                                                : <div className='col-lg-1'></div>
                                        }
                                    </div>
                                    
                                ))
                                }
                                <button className="btn btn-primary btn-icon btn-rounded float-right ml-2 mb-2" type="button" onClick={() => this.addFormFields()}><i className='bi bi-plus'></i></button>
                                <div className='clearfix'></div>
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-primary float-left" type="submit">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(EditService);
